module.exports = __webpack_public_path__ + "static/header_title_mobile_de-3e5ee8ebf9020bc257990ff8ebf93a9b.png";